"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.commsType.wa': 'WA',
    'whatsapp.commsType.tele': 'Telegram',
    'whatsapp.commsType.email': '电子邮件',
};
